import Axios from "axios";
import { baseUrl } from "../config/base-url";

export function login(data) {
  return Axios({
    url: `${baseUrl()}/login`,
    method: "POST",
    data,
  });
}
